import { render, staticRenderFns } from "./c2cIndexList.vue?vue&type=template&id=802fc946&scoped=true&"
import script from "./c2cIndexList.vue?vue&type=script&lang=js&"
export * from "./c2cIndexList.vue?vue&type=script&lang=js&"
import style0 from "./c2cIndexList.vue?vue&type=style&index=0&id=802fc946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802fc946",
  null
  
)

export default component.exports